/**
 * Centralized client-side logging helper.
 *
 * All call sites in src/ MUST go through this module — never call
 * `console.*` directly outside this file. The `no-console` ESLint rule is
 * enabled globally with a single-file override here (see package.json's
 * `eslintConfig.overrides`).
 *
 * Behavior:
 *   - Development build (NODE_ENV !== "production")
 *       → logs to the browser console with structured context
 *   - Production build (NODE_ENV === "production")
 *       → silent (no logging anywhere). Production-meaningful wiring to
 *         Sentry / LogRocket / PostHog is deliberately deferred to a later
 *         phase; today we keep the helper minimal and silent in prod.
 *
 * Contract:
 *   logger.error(message, context?)
 *   logger.warn(message, context?)
 *   logger.info(message, context?)
 *
 *   `message` is a short kebab/snake-case event tag (e.g.,
 *   "audit_start_failed"). `context` is an optional plain object with the
 *   variable fields (status, sessionId, err message, etc.).
 */

/* eslint-disable no-console */

const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export const logger = {
  error: (message, context) => {
    if (isDev) console.error(message, context || {});
  },
  warn: (message, context) => {
    if (isDev) console.warn(message, context || {});
  },
  info: (message, context) => {
    if (isDev) console.info(message, context || {});
  },
};

export default logger;
